import * as React from 'react';
import styled from 'styled-components';

import { useLocation } from 'react-router';
import { useFadeTransition } from '../../../../utils/hooks/useFadeTransition';
import { Seo } from '../../../../utils/seo/Index';
import { BackgroundLoad } from '../../../layout/BackgroundLoad';
import { Container } from '../../../layout/Container';
import { Heading } from '../../../ui/text/Heading';
import { Paragraph } from '../../../ui/text/Paragraph';
import { Section } from '../../../layout/Section';
import { FormSection } from '../../../ui/form/FormSection';

const FilmFestStyle = styled.div`
  margin-top: 17em;
`;

const FilmFest: React.FC = () => {
  const location = useLocation();
  const { fadeIn: pageFadeIn } = useFadeTransition({
    immidiate: true,
  });

  return (
    <>
      <Seo
        title="Filmfest - PrivatMegleren"
        description="Vi feirer 10 år på Kolbotn og ønsker dere velkommen til filmfest"
        url={location.pathname}
      />

      <Container style={{ ...pageFadeIn, marginTop: '-2em' }}>
        <Section className="form-section">
          <FilmFestStyle>
            <Heading tag="h2" center={true}>
              Alle billetter er nå utsolgt
            </Heading>
          </FilmFestStyle>
        </Section>

        <BackgroundLoad
          height={'90vh'}
          opacity={0.6}
          showOnMobile={true}
          position={'top center'}
          url="https://cdn.reeltime.no/pm_assets/kampanjer/kolbotn/Kolben_Kolbotn_10aar_ny.jpg"
        />
        {/*        <FormSection /> */}
      </Container>
    </>
  );
};

export default FilmFest;
